import { api } from '@/shared/api/axios';
import type {
  ChatRequest, ChatResponse, FollowUpDraftRequest, FollowUpDraftResponse,
  GreetingResponse, MeetingAgendaResponse,
} from '../types';
import { withAiApiError } from './errors';
import { aiApiPaths } from './paths';
export { streamChat } from './stream';

export const aiAssistantApi = {
  greeting: () => withAiApiError(async () =>
    (await api.get<GreetingResponse>(aiApiPaths.greeting)).data),
  chat: (input: ChatRequest) => withAiApiError(async () =>
    (await api.post<ChatResponse>(aiApiPaths.chat, input)).data),
  followUpDraft: (input: FollowUpDraftRequest) => withAiApiError(async () =>
    (await api.post<FollowUpDraftResponse>(aiApiPaths.followUpDraft, input)).data),
  meetingAgenda: (meetingId: string) => withAiApiError(async () =>
    (await api.post<MeetingAgendaResponse>(aiApiPaths.meetingAgenda, { meetingId })).data),
};
